export function isRouteActive(route: string, pathname: string, strict = false) {
  if (strict || route === '/') {
    return route === pathname;
  }

  return pathname.startsWith(route);
}
